<template>
	<div v-if="display" class="row bg-title">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="pull-left">
				<i v-if="canGo.back" @click="go(-1)" class="fa fa-chevron-left fa-2x link custom-chevron" aria-hidden="true"></i>
			</div>
			<div class="custom-breadcrumb">
				<template v-if="items">
					<template v-if="items.length">
						<template v-for="(item, key) in items">
							<router-link :to="item.path" :class="{ 'disabled' : key == items.length - 1 }">
								{{ item.name }}
							</router-link>
							<template v-if="key < items.length - 1">
								>
							</template>
						</template>
					</template>
				</template>
			</div>
		</div>
		<!--
		<div class="col-lg-9 col-md-8 col-sm-8 col-xs-6">
			<div class="btn-toolbar pull-right" role="toolbar" aria-label="...">
				<div class="btn-group" role="group" aria-label="...">
					<button type="button" class="btn btn-info">
						<i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>
		-->
	</div>
</template>

<script>

export default {
	props: ['user', 'isAuth'],
	data() {
		return {
			title: null,
			items: [],
			display: false,
			canGo: {
				back: false,
			}
		}
	},
	watch: {
		'$route'() {
			this.canDisplay()
			this.loadItems()
			this.canGoBack()
		}
	},
	created() {
		this.canDisplay()
		this.loadItems()
		this.canGoBack()
	},
	methods: {
		canGoBack() {
			this.canGo.back = window.history.length > 1
		},
		go(record) {
			this.$router.go(record)
		},
		loadItems() {
			var pathArray = window.location.pathname.split('/')
			pathArray.splice(0, 1)
			pathArray.splice(0, 1)
			pathArray.splice(0, 1)
			pathArray.splice(0, 1)

			if(pathArray.length) {
				this.items = []
				var that = this
				pathArray.forEach(function(path, key) {
					if(path) {
						var number = +path
						if(isNaN(number)) {
							var name = that.$t("breadcrumb." + path)
						} else {
							var name = path
						}
						var url = '/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin'
						if(key > 0) {
							var length = pathArray.length
							var index = key + 1
							var count = 0
							while(count < index) {
								url += '/' + pathArray[count]
								count++
							}
						} else {
							url += '/' + path
						}
						var item = {
							name: name,
							path: url,
						}
						that.items.push(item)
					}
				})
			}
		},
		canDisplay() {
			this.display = false
			if(this.$route) {
				if(this.$route.meta) {
					if(this.$route.meta.forAuth) {
						this.display = true
					}
				}
			}
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/partials/views/Breadcrumb.vue